import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FavoritesListComponent } from './favorites-list/favorites-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from "ng-inline-svg-2";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RouterModule } from '@angular/router';
import { NgxShimmerLoadingModule } from 'ngx-shimmer-loading';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    InlineSVGModule,
    DragDropModule,
    TranslateModule,
    RouterModule,
    NgxShimmerLoadingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  declarations: [FavoritesListComponent],
  exports: [FavoritesListComponent]
})
export class SharedFavoritesModule {}
